import { Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import {
  ConfirmationDialog,
  FormTitleBox,
  PaginationTable,
} from '../../common/components';
import CashAccountDrawer from './components/CashAccountDrawer';
import CashAccountsDataTable from './components/CashAccountsDataTable';
import useCashAccountsController from './hooks/useCashAccountsController';

const CashAccounts = () => {
  const {
    accountToDelete,
    cancelDelete,
    closeDrawer,
    confirmDelete,
    createCashAccount,
    deleteDialogOpen,
    drawerOpen,
    editMode,
    isDeleting,
    isLoading,
    isSubmitting,
    openCreateDrawer,
    openEditDrawer,
    pagination,
    requestDelete,
    selectedAccount,
    updateCashAccount,
  } = useCashAccountsController();

  return (
    <Box>
      <FormTitleBox
        title="Finanzas | Cajas"
        showButton
        buttonText="Nueva caja"
        buttonIcon={AddIcon}
        onButtonClick={openCreateDrawer}
        showSearch
        searchLabel="Buscar caja"
        searchValue={pagination.searchTerm}
        onSearchChange={pagination.handleSearch}
        searchSize="medium"
      />

      <CashAccountsDataTable
        accounts={pagination.data}
        isLoading={isLoading}
        onEdit={openEditDrawer}
        onDelete={requestDelete}
      />

      {pagination.totalCount > 0 && (
        <PaginationTable
          page={pagination.page}
          totalPages={pagination.totalPages}
          totalCount={pagination.totalCount}
          rowsPerPage={pagination.rowsPerPage}
          onPageChange={pagination.handlePageChange}
          onRowsPerPageChange={pagination.handleRowsPerPageChange}
        />
      )}

      <CashAccountDrawer
        open={drawerOpen}
        onClose={closeDrawer}
        editMode={editMode}
        selectedAccount={selectedAccount}
        onCreate={createCashAccount}
        onUpdate={updateCashAccount}
        isSubmitting={isSubmitting}
      />

      <ConfirmationDialog
        open={deleteDialogOpen}
        onClose={cancelDelete}
        onConfirm={confirmDelete}
        title="Eliminar caja"
        message={
          accountToDelete
            ? `¿Confirmás eliminar la caja "${accountToDelete.name}"?`
            : '¿Confirmás eliminar la caja seleccionada?'
        }
        isLoading={isDeleting}
      />
    </Box>
  );
};

export default CashAccounts;
